import React from "react";
import { Card } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function SkeletonDetailsContetnt() {
  return (
    <>
      <Card className="p-2 rounded-3 text-center">
        <Skeleton width="184px" height="138px"></Skeleton>
        <Card.Body className="px-0 pb-0">
          <Card.Title className="text-black fw-bold fs-normal">
            <Skeleton height="10px"></Skeleton>
          </Card.Title>
          <Card.Text className="text-black-06 ">
            <Skeleton height="10px"></Skeleton>
          </Card.Text>
          <Skeleton height="38px"></Skeleton>
        </Card.Body>
      </Card>
    </>
  );
}

export default SkeletonDetailsContetnt;
